import {
  ChangeDetectionStrategy,
  Component,
  ContentChild,
  EventEmitter,
  Input,
  Output,
  TemplateRef,
} from '@angular/core';
import { NgFor, NgStyle, NgClass, NgTemplateOutlet } from '@angular/common';

@Component({
  selector: 'app-select-group',
  templateUrl: './select-group.component.html',
  styleUrls: ['./select-group.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [NgFor, NgStyle, NgClass, NgTemplateOutlet],
})
export class SelectGroupComponent {
  @Input() selectionMode!: SelectGroupMode;
  @Input() itemList!: ISelectable[];
  @Input() itemSpace = '0';
  @Output() itemChange: EventEmitter<ISelectable> = new EventEmitter();
  @ContentChild(TemplateRef) itemTemplate!: TemplateRef<any>;

  constructor() {}

  ngOnInit(): void {}

  onItemClick(item: any): void {
    if (this.selectionMode === SelectGroupMode.single) {
      if (item.isSelected) {
        return;
      }

      this.itemList.forEach((oneItem) => {
        oneItem.isSelected = false;
      });
      item.isSelected = true;
    } else {
      item.isSelected = !item.isSelected;
    }

    this.itemChange.emit(item);
  }

  itemsToDisplayTrackBy(index: number, item: ISelectable) {
    return (item as any).key;
  }
}

export enum SelectGroupMode {
  single,
  multiple,
}

export interface ISelectable {
  isSelected?: boolean;
}
